import { useTheme } from '@mui/material'

import { Carousel } from '@/components/Carousel/Carousel'
import { ProductCard } from '@/components/ProductCard/ProductCard'
import { useActionsOfFavoriteList } from '@/hooks/useActionsOfFavoriteList'
import { ProductListTrackingProvider } from '@/providers/ProductListTrackingProvider'

import type React from 'react'
import type { ListContext } from '@/lib/eventBus/trackingEvents'

interface ProductCarouselProps {
  listContext: ListContext
  numberOfProductsToShow: number
  productsIds: string[]
}

export const ProductCarousel: React.FC<ProductCarouselProps> = ({
  listContext,
  numberOfProductsToShow,
  productsIds,
}) => {
  const theme = useTheme()
  const { getListOfFavoriteList } = useActionsOfFavoriteList(productsIds)

  return (
    <ProductListTrackingProvider listContext={listContext} productCodes={productsIds}>
      <Carousel
        sx={{
          px: 0,
          py: 3,

          '& .regular': {
            display: 'flex',
          },
          '& .MuiBox-root': {
            minHeight: 'inherit',
          },
          '.slick-slide': {
            [theme.breakpoints.up('lg')]: {
              maxWidth: numberOfProductsToShow < 4 ? '25%' : 'unset',
            },
          },
        }}
        items={productsIds.map((id) => (
          <ProductCard
            key={id}
            productCode={id}
            favoriteListsIds={getListOfFavoriteList(id)}
            shouldRetryProductLoad={false}
          />
        ))}
        settingsOverride={{
          slidesToShow: numberOfProductsToShow <= 4 ? numberOfProductsToShow : 4,
          slidesToScroll: 4,
          responsive: [
            {
              breakpoint: theme.breakpoints.values.xl,
              settings:
                numberOfProductsToShow <= 4
                  ? 'unslick'
                  : {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                    },
            },
            {
              breakpoint: theme.breakpoints.values.lg,
              settings:
                numberOfProductsToShow <= 3
                  ? 'unslick'
                  : {
                      slidesToShow: 3,
                      slidesToScroll: 3,
                    },
            },
            {
              breakpoint: theme.breakpoints.values.md,
              settings:
                numberOfProductsToShow <= 2
                  ? 'unslick'
                  : {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                    },
            },
            {
              breakpoint: theme.breakpoints.values.sm,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        }}
      />
    </ProductListTrackingProvider>
  )
}
